import { useEffect, useState } from "react";
import classes from "./InfoQuestionsOrdering.module.css";
import InfoQuestion from "../../../../ts/models/InfoQuestion";
import { getInfoQuestions } from "../../../../services/masters";
import { Column } from "../../../../ts/types";
import Modal, {
  ModalBody,
  ModalFooter,
} from "../../../../components/Modal/Modal";
import DragDropTable from "../../../../components/CustTable/DragDropTable";
import PrimaryButton from "../../../../components/Buttons/PrimaryButton";

type Props = {
  items: InfoQuestion[];
  onClose: () => void;
  setItemsHandler: (items: Set<string>) => void;
};

const InfoQuestionsOrdering: React.FC<Props> = ({
  items,
  onClose,
  setItemsHandler,
}) => {
  const [tableData, setTableData] = useState(items);
  const [selectedInfoQuestions, setSelectedInfoQuestions] = useState<
    InfoQuestion[]
  >([]);

  useEffect(() => {
    const fetchInfoQuestionsFromIds = async () => {
      const logicQuestions = items.filter((data) => data.logicQuestion);
      const infoQuestionIds = logicQuestions.map(
        (infoQues) => infoQues.logicQuestion
      );

      if (infoQuestionIds?.length) {
        try {
          const infoQuestionRes = await getInfoQuestions(infoQuestionIds);
          if (infoQuestionRes.status) {
            setSelectedInfoQuestions(infoQuestionRes.data);
          }
        } catch (err) {
          console.log(err);
        }
      } else {
        setSelectedInfoQuestions([]);
      }
    };

    fetchInfoQuestionsFromIds();
  }, []);

  const getQuestionById = (questionId?: string) => {
    return selectedInfoQuestions.find((question) => question.id === questionId);
  };

  const columns: Column<InfoQuestion>[] = [
    {
      header: "ID",
      accessor: (e, idx) => idx + 1,
      width: "8%",
    },
    {
      header: "CODE",
      accessor: (e) => e.code,
      width: "8%",
    },
    {
      header: "QUESTION",
      accessor: (e) => e.question,
      width: "36%",
    },
    {
      header: "SHOWN WHEN",
      accessor: (e) => getQuestionById(e.logicQuestion)?.question || "",
      width: "36%",
    },
    {
      header: "RESPONSE IS",
      accessor: (e) => e.logicQuestionResponse || "",
      width: "12%",
    },
  ];

  const itemsHandler = () => {
    const itemIdsSet = new Set(
      tableData.map((infoQuestion) => infoQuestion.id)
    );
    setItemsHandler(itemIdsSet);
    onClose();
  };

  return (
    <Modal title={<>Change Info Questions Ordering</>} onClose={onClose}>
      <>
        <ModalBody>
          <>
            <div className={classes.main}>
              <DragDropTable
                columns={columns}
                data={tableData}
                setUpdateData={(infoQuestions: InfoQuestion[]) =>
                  setTableData(infoQuestions)
                }
              />
            </div>
            <div className={classes.information}>
              Drag and drop to change the question order.
            </div>
          </>
        </ModalBody>
        <ModalFooter>
          <div className={classes.actions}>
            <PrimaryButton name='OK' onClick={itemsHandler} />
            <PrimaryButton
              className={classes.actionBtn}
              name='Cancel'
              onClick={onClose}
              transparent
            />
          </div>
        </ModalFooter>
      </>
    </Modal>
  );
};

export default InfoQuestionsOrdering;
